import { REFRESH_URL, EXTRA_TOKEN, REFRESH_TOKEN, ID_TOKEN, TOKEN_TYPE, EXPIRE, USER_INFO, LANGUAGE } from './Constants';
import { setItem, getItem } from './storage';
import { putService } from '../services/RequestServices';


let refreshTokenTimeoutID = 0;

export let lang = "es";

export function storeUserInfo(info) {
    setItem(USER_INFO, JSON.stringify(info));
}

export function getUserInfo() {
    let userInfo = getItem(USER_INFO);
    if(userInfo !== null) {
        return JSON.parse(userInfo);
    }
    else {
        return {name: ""};
    }
}

export function setSelectedLanguage(lang) {
    setItem(LANGUAGE, lang);
}

export function setTokens(tokenObject) {
    if (tokenObject.hasOwnProperty("RefreshToken"))
    setItem(REFRESH_TOKEN, tokenObject.RefreshToken);
    setItem(EXTRA_TOKEN, tokenObject.ExtraToken);
    setItem(ID_TOKEN, tokenObject.IdToken);
    setItem(TOKEN_TYPE, tokenObject.TokenType);
    setItem(EXPIRE, tokenObject.Expire);

    setTimeoutForRefreshToken();
}

export function setGoVersion(goVersion, versionWP, versionWA) {
    setItem("goVersion", goVersion);
    setItem("goVersionWP", versionWP);
    setItem("goVersionWA", versionWA);
}

export function getTokens() {
    let tokenObject = {};
    tokenObject.RefreshToken = getItem(REFRESH_TOKEN);
    tokenObject.ExtraToken = getItem(EXTRA_TOKEN);
    tokenObject.IdToken = getItem(ID_TOKEN);
    tokenObject.TokenType = getItem(TOKEN_TYPE);
    tokenObject.Expire = getItem(EXPIRE);

    return tokenObject;
}

export function setTimeoutForRefreshToken() {
    if (!(getItem(EXPIRE) && (Number(getItem(EXPIRE)) * 1000) > Date.now())) {
        return;
    }

    clearTimeout(refreshTokenTimeoutID);
    refreshTokenTimeoutID = setTimeout(() => {
        refreshTokens();
    }, ((Number(getItem(EXPIRE)) * 1000) - Date.now()));
}

function refreshTokens() {
    let data = {
        RefreshToken: getItem(REFRESH_TOKEN)
    }

    putService(REFRESH_URL, JSON.stringify(data), setTokens, refreshTokenError);
}

function refreshTokenError(error) {
    console.log("Refresh Token - Request Failed");
}